<template>
  <div
    v-html="loadSvg"
    :style="{ color: color }"
  />
</template>

<script setup>
import { computed, ref } from 'vue'
import rawSvg from '@/assets/tip-arrow.svg?raw'

const props = defineProps({
  color: {
    type: String,
    default: '#4681F9'
  }
})

const loadSvg = computed(() => {
  return rawSvg.replace(/fill="[^"]*"/g, 'fill="currentColor"')
})
</script>

<style lang='less' scoped>
</style>
